export const version = "3.1.0" //DWM Sprint 6 2026
export const build = 774